"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _Logo = _interopRequireDefault(require("../../shared/Logo"));

var _Icon = _interopRequireDefault(require("@emcasa/ui-dom/components/Icon"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _Button = _interopRequireDefault(require("@emcasa/ui-dom/components/Button"));

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_Logo["default"], {});

var _ref3 =
/*#__PURE__*/
(0, _jsx2["default"])(_Icon["default"], {
  name: "times",
  height: "20px"
});

function Header(_ref) {
  var onClose = _ref.onClose;
  return (0, _jsx2["default"])(_Row["default"], {
    justifyContent: "space-between",
    mb: "32px"
  }, void 0, _ref2, (0, _jsx2["default"])(_Button["default"], {
    link: true,
    onClick: onClose,
    p: 0,
    height: "20px"
  }, void 0, _ref3));
}